import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from '../../e-met/services/data.service';

@Pipe({
    name: 'documentsName',
})
export class DocumentsNamePipe implements PipeTransform {
    constructor(private dataService: DataService) {}
    transform(id: string): any {
        return this.dataService.getDocumentTypeNameFromID(id.toString());
    }
}
